import { render, staticRenderFns } from "./add-dictionary-child.vue?vue&type=template&id=2b8726cf"
import script from "./add-dictionary-child.vue?vue&type=script&lang=ts"
export * from "./add-dictionary-child.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports